module.exports = __webpack_public_path__ + "img/SHIELD.372e0c28.svg";